// opervex-frontend/src/Opervex/Accounting/Cities.js

class Cities {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async create(data) {
    return this.#_api.post("/Accounting/Cities/", data);
  }

  async update(id, data) {
    return this.#_api.put("/Accounting/Cities/" + id, data);
  }

  async findId(id) {
    return this.#_api.get("/Accounting/Cities/" + id);
  }

  async findAll() {
    return this.#_api.get("/Accounting/Cities");
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "name",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default Cities;
